import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { useCall } from '../../contexts/CallContext';
import IncomingCallModal from './IncomingCallModal';
import OutgoingCallModal from './OutgoingCallModal';
import ActiveCallScreen from './ActiveCallScreen';

const CallOverlay = () => {
  const {
    callState,
    callInfo,
    localStream,
    remoteStream,
    isMuted,
    isVideoOff,
    callDuration,
    acceptCall,
    declineCall,
    endCall,
    cancelCall,
    toggleMute,
    toggleVideo,
  } = useCall();

  return (
    <AnimatePresence>
      {callState === 'incoming' && (
        <IncomingCallModal
          key="incoming"
          callInfo={callInfo}
          onAccept={acceptCall}
          onDecline={declineCall}
        />
      )}

      {callState === 'outgoing' && (
        <OutgoingCallModal
          key="outgoing"
          callInfo={callInfo}
          onCancel={cancelCall}
        />
      )}

      {callState === 'connected' && (
        <ActiveCallScreen
          key="active"
          callInfo={callInfo}
          localStream={localStream}
          remoteStream={remoteStream}
          isMuted={isMuted}
          isVideoOff={isVideoOff}
          callDuration={callDuration}
          onToggleMute={toggleMute}
          onToggleVideo={toggleVideo}
          onEndCall={endCall}
        />
      )}
    </AnimatePresence>
  );
};

export default CallOverlay;
